import React from 'react';

const SectionHeading = ({ text }) => {
  return <h2 className="section-heading">{text}</h2>;
};

export default SectionHeading;
